import { Card, Grid } from "@scuf/common";
import { useEffect, useState } from "react";
import MineralCard from "../../../components/mineral-card/MineralCard";
import VECTOR_MINERALES from "../../../json/vector-minerales";
import { getResultadosDomoAjustesAAQQ } from "../../../services/services";

export default function MineralContainer() {
  const [isLoading, setIsLoading] = useState(false);
  const [minerales, setMinerales] = useState(VECTOR_MINERALES);

  function SetMineralsData(data) {
    let updatedArray = minerales;
    Object.keys(data).forEach((key) => {
      updatedArray = updatedArray.map((obj) => {
        if (obj.name === key) {
          if (typeof data[key] === "number") {
            return { ...obj, value: data[key].toFixed(2) };
          }
          return { ...obj, value: data[key] };
        }
        return obj;
      });
    });
    setMinerales(updatedArray);
  }

  useEffect(() => {
    const fData = async () => {
      const { data } = await getResultadosDomoAjustesAAQQ();

      if (data) {
        setIsLoading(false);
        SetMineralsData(data[0]);
      }

      setTimeout(() => {
        fData();
      }, 60000);
    };

    fData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <Card.Header title="Minerales" />
        <Grid>
          <Grid.Row>
                {minerales.map((item, index) => (
                  <Grid.Column
                    key={index}
                    width={item.name === "Metodo" ? 4 : 2}
                    xsWidth={8}
                  >
                    <MineralCard
                      key={index}
                      title={item.name}
                      unit={item.unit}
                      value={item.value}
                      isLoading={isLoading}
                    />
                  </Grid.Column>
                ))}
          </Grid.Row>
        </Grid>
      </Card>
    </>
  );
}
